var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "emd-text-section" },
    [
      _vm.title
        ? _c(
            "emd-text",
            {
              staticClass: "emd-text-section__title",
              attrs: { size: "section", "data-testid": "title" },
            },
            [_vm._v(" " + _vm._s(_vm.title) + " ")]
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "emd-text-section__container",
          attrs: { "data-testid": "slot-content" },
        },
        [_vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }